export const antsStoreData = [
  {
    "param": "item",
    "value": "Tactic Ogre (JP)"
  },
  {
    "param": "price",
    "value": "1990 THB"
  },
  {
    "param": "estimate_date",
    "value": "2023/06/02"
  },
  {
    "param": "link_url_btn",
    "value": "https://www.ants.co.th/"
  }]

export const antsPaymentData = [
  {
    "param": "paid_amount",
    "value": "1,000.00"
  },
  {
    "param": "item",
    "value": "ANTS SMS "
  },
  {
    "param": "merchant",
    "value": "ANTS"
  },
  {
    "param": "date",
    "value": "10 Jan 2023 13:00"
  },
  {
    "param": "pay_method",
    "value": "PromptPay"
  },
  {
    "param": "link_url_btn",
    "value": "https://www.google.com/"
  }]

export const antsRegiatrationData = [
  {
    "param": "company_name",
    "value": "ANTS"
  },
  {
    "param": "company_name",
    "value": "ANTS"
  },
  {
    "param": "service_name",
    "value": "ANTS001"
  },
  {
    "param": "registration_date",
    "value": "16 Jun 2023 13:00"
  },
  {
    "param": "link_url_btn",
    "value": "https://www.ants.co.th/"
  }
]


// WEBPACK FOOTER //
// ./src/@fake-db/sendPage/templateData.js